import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { OrdersCoServices } from '../../../services';
/**
 * Component para la generacion de la lista agrupada de tickets en el tpv ademas de su opcion
 * de count, no count y delete
 */

@Component({
  selector: 'page-orders-select-selected-list',
  templateUrl: 'orders-select-selected-list.html',
})
export class OrdersSelectSelectedListPage {
  @Input() selected_list: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices) {

  }

  deleteTableList(valueSearch, index, element) {
    if (element.type != 'combo') {//casos normales
      this.ordersCoServices.deleteTableList(valueSearch, index);
      this.ordersCoServices.count_elements--;
    } else {//caso combo
      var order_tmp = this.globals.objectToArray(this.ordersCoServices.order_tmp);
      for (let s_key in order_tmp) {
        var _list = this.globals.objectToArray(order_tmp[s_key].list);
        for (let e_key in _list) {
          if (element.uid_combo_tmp == order_tmp[s_key].list[e_key].uid_combo_tmp) {
            delete this.ordersCoServices.order_tmp[s_key].list[Number(e_key)];
          }
        }
      }
      //
      this.ordersCoServices.deleteTableList(valueSearch, index);
      this.ordersCoServices.count_elements--;
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-select/orders-select-selected/orders-select-selected-list/orders-select-selected-list.ts